import { Edit, Eye, MoreVertical, Trash2 } from 'lucide-react';

import { ConfirmationDialog } from '@web/components/ui/confirmation-dialog';
import { useState } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './dropdown-menu';
import { Button } from './button';

export type RowActions = {
  /** Callback for "Details" action. If `undefined`, the action is hidden. */
  details?: () => void | Promise<void>;
  /** Callback for "Edit" action. If `undefined`, the action is hidden. */
  edit?: () => void | Promise<void>;
  /** Callback for "Delete" action. If `undefined`, the action is hidden. */
  delete?: () => void | Promise<void>;
};

type ActionsMenuProps = {
  actions: RowActions;
};

export function ActionsMenu({ actions }: Readonly<ActionsMenuProps>) {
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const hasAnyAction = actions.details ?? actions.edit ?? actions.delete;

  // If no actions provided, hide the 3-dot button
  if (!hasAnyAction) return null;

  return (
    <>
      <DropdownMenu>
        {/* 3-dot trigger */}
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="" aria-label="Open row actions">
            <MoreVertical size={18} />
          </Button>
        </DropdownMenuTrigger>

        <DropdownMenuContent className="" align="end" sideOffset={6}>
          {/* Details */}
          {actions.details && (
            <DropdownMenuItem
              onClick={() => {
                console.log('details');
                void actions.details?.();
              }}
              className=""
            >
              <Eye size={14} className="mr-2" />
              Details
            </DropdownMenuItem>
          )}

          {/* Edit */}
          {actions.edit && (
            <DropdownMenuItem
              onSelect={() => void actions.edit?.()}
              className=""
            >
              <Edit size={14} className="mr-2" />
              Edit
            </DropdownMenuItem>
          )}

          {/* Delete (opens Confirmation Dialog) */}
          {actions.delete && (
            <DropdownMenuItem
              // Do NOT prevent default inside this callback
              onSelect={() => {
                setDeleteDialogOpen(true);
              }}
              className=""
            >
              <Trash2 size={14} className="mr-2" />
              Delete
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>

      {/* Delete Confirmation Dialog */}
      <ConfirmationDialog
        open={deleteDialogOpen}
        onOpenChange={setDeleteDialogOpen}
        title="Delete record?"
        description="This action cannot be undone. Do you want to proceed?"
        confirmLabel="Delete"
        destructive
        onConfirm={() => {
          void actions.delete?.();
          setDeleteDialogOpen(false);
        }}
        onCancel={() => {
          console.log('cancel, closing dialog');
          setDeleteDialogOpen(false);
        }}
      />
    </>
  );
}
